import React from 'react';

const SearchIcon = ({ width = 24, height = 24, fill = '#0F7F85', ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6506 3C16.4205 3 20.3004 6.79428 20.3004 11.459C20.3004 13.6597 19.4367 15.667 18.0235 17.1734L20.8044 19.8873C21.0646 20.1418 21.0655 20.5535 20.8053 20.808C20.6756 20.9366 20.5041 21 20.3336 21C20.1639 21 19.9934 20.9366 19.8628 20.8098L17.0484 18.0651C15.5679 19.2246 13.6906 19.9188 11.6506 19.9188C6.88075 19.9188 3 16.1236 3 11.459C3 6.79428 6.88075 3 11.6506 3ZM11.6506 4.30298C7.61533 4.30298 4.33237 7.51266 4.33237 11.459C4.33237 15.4053 7.61533 18.6158 11.6506 18.6158C15.685 18.6158 18.968 15.4053 18.968 11.459C18.968 7.51266 15.685 4.30298 11.6506 4.30298Z"
        fill={fill}
      />
    </svg>
  );
};

export default SearchIcon;

